import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IVehicleData } from '../../../../core/models/vehicle-data.model';
import { BrandingIds } from '../../../../core/enums/branding.enum';
import { DataManagmentService } from '../../../../core/services/data-service';
import { SummaryService } from '../../../../core/services/summary.service';
import { FunnelService } from '../funnel/funnel.service';
import { SharedStateService } from '../../../../core/services/first-layer.service';

@Component({
  selector: 'app-landing-page',
  standalone: false,
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent implements OnInit {
  ngOnInit(): void {
    this.getDataFromUrl();
    this.stateService.setShowManualForm(true);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataManagmentService,
    private summaryData: SummaryService,
    private funnelService: FunnelService,
    private stateService: SharedStateService
  ) {
    this.brandingId = localStorage.getItem('brandingId') ?? '';
    // this.funnelService.getBrandingStyles(this.brandingId).subscribe((data) => {
    //   console.log('Branding styles:', data);

    //   document.documentElement.style.setProperty('--background-color', data.BackgroundColor);
    //   document.documentElement.style.setProperty('--text-color', data.TextColor);
    //   document.documentElement.style.setProperty('--button-text-color', data.ButtonTextColor);

    //   if (data.ButtonColor.length > 1) {
    //     document.documentElement.style.setProperty('--button-gradient-start', data.ButtonColor[0]);
    //     document.documentElement.style.setProperty('--button-gradient-middle', data.ButtonColor[1]);
    //     document.documentElement.style.setProperty('--button-gradient-end', data.ButtonColor[2]);
    //   } else {
    //     document.documentElement.style.setProperty('--button-gradient-start', data.ButtonColor[0]);
    //     document.documentElement.style.setProperty('--button-gradient-end', data.ButtonColor[0]);
    //   }

    //   this.logoUrl = data.LogoUrl;
    // });
  }

  currentIndex = 0;

  slides = [
    {
      image: 'assets/images/slide1.svg',
      title: 'En Cafler cuidamos de tu vehículo por ti',
      description:
        'Nos encargamos de tu vehículo para que tú solo disfrutes...',
    },
    {
      image: 'assets/images/slide2.svg',
      title: 'Introduce la matrícula de tu vehículo',
      description: 'Comienza ingresando la matrícula para identificarlo...',
    },
    {
      image: 'assets/images/slide3.svg',
      title: 'Indica la dirección de recogida y devolución',
      description: 'El conductor recogerá tu coche donde lo necesites...',
    },
    {
      image: 'assets/images/slide4.svg',
      title: 'Elige el servicio que necesita tu vehículo',
      description: 'Elige entre nuestra variedad de servicios...',
    },
  ];

  next() {
    if (this.currentIndex < this.slides.length - 1) {
      this.currentIndex++;
    } else {
      this.redirectToForm();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  skip() {
    this.router.navigate(['/funnel/vehicle-data']);
  }

  vehicleData!: IVehicleData;
  isLanding = false;
  logoUrl = '';
  brandingId = '';

  getDataFromUrl(): void {
    this.route.queryParams.subscribe((params) => {
      const { licensePlate, model, brandingId, vehicleType, fuelType } = params;

      if (!licensePlate || !model || !brandingId) {
        return;
      }

      const brandingKey =
        Object.keys(BrandingIds).find(
          (key) => BrandingIds[key as keyof typeof BrandingIds] === brandingId
        ) ?? 'UNKNOWN';

      this.vehicleData = {
        licensePlate,
        model,
        vehicleType: Number(vehicleType),
        fuelType: Number(fuelType),
        brandingId,
        brand: brandingKey,
      };

      this.brandingId = brandingId;
      this.dataService.setVehicleData(this.vehicleData);

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { brandingId },
        replaceUrl: true,
      });
    });
  }

  redirectToForm(): void {
    const brandingId = this.route.snapshot.queryParamMap.get('brandingId');

    this.router.navigate(['/funnel/vehicle-data'], {
      queryParams: { brandingId },
    });
  }
}
